// src/components/fraud/BlacklistDeleteConfirm.js
// Confirmation dialog before deleting a blacklist entry.
// Shows all populated identifier fields for the entry being deleted.

import React from 'react';
import { Modal } from 'react-bootstrap';
import { IDENTIFIER_FIELDS } from '../../hooks/useBlacklist';

const BlacklistDeleteConfirm = ({ open, entry, onClose, onConfirm, opLoading }) => {
  if (!entry) return null;

  const populatedIds = IDENTIFIER_FIELDS.filter((f) => entry[f.key]);

  return (
    <Modal
      show={open}
      onHide={onClose}
      centered
      backdrop={opLoading ? 'static' : true}
      size="sm"
    >
      <div style={{ background: 'var(--bg-surface)', border: '1px solid rgba(239,68,68,0.25)', borderRadius: 12, overflow: 'hidden' }}>

        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '18px 20px', borderBottom: '1px solid var(--divider)' }}>
          <span style={{ fontSize: 20 }}>🗑</span>
          <div>
            <h6 style={{ margin: 0, fontWeight: 700, color: '#EF4444', fontSize: 14 }}>Delete Entry</h6>
            <small style={{ color: 'var(--text-secondary)', fontSize: 11 }}>This action cannot be undone</small>
          </div>
        </div>

        {/* Body */}
        <div style={{ padding: '20px' }}>
          <p style={{ color: 'var(--text-primary)', fontSize: 13, marginBottom: 14 }}>
            Are you sure you want to permanently delete this blacklist entry?
          </p>

          {/* Entry summary */}
          <div style={{ background: 'rgba(239,68,68,0.06)', border: '1px solid rgba(239,68,68,0.2)', borderRadius: 8, padding: '12px 14px' }}>
            {populatedIds.length === 0 ? (
              <small style={{ color: 'var(--text-secondary)', fontSize: 11 }}>(no identifiers)</small>
            ) : (
              populatedIds.map((f) => (
                <div key={f.key} style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: f !== populatedIds[populatedIds.length - 1] ? 6 : 0 }}>
                  <span style={{ fontSize: 9, fontWeight: 700, color: f.color, background: `${f.color}18`, border: `1px solid ${f.color}44`, borderRadius: 3, padding: '1px 5px', textTransform: 'uppercase', flexShrink: 0 }}>
                    {f.label}
                  </span>
                  <span style={{ fontSize: 12, fontFamily: 'monospace', color: 'var(--text-primary)', wordBreak: 'break-all' }}>
                    {entry[f.key]}
                  </span>
                </div>
              ))
            )}
            {entry.reason && (
              <small style={{ color: 'var(--text-secondary)', fontSize: 11, display: 'block', marginTop: 8 }}>
                Reason: {entry.reason}
              </small>
            )}
          </div>
        </div>

        {/* Footer */}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, padding: '14px 20px', borderTop: '1px solid var(--divider)' }}>
          <button
            onClick={onClose} disabled={opLoading}
            style={{ background: 'transparent', border: '1px solid rgba(255,255,255,0.15)', borderRadius: 8, color: 'var(--text-secondary)', fontSize: 13, fontWeight: 600, padding: '7px 16px', cursor: 'pointer' }}
          >
            Cancel
          </button>
          <button
            id="bl-delete-confirm-btn"
            onClick={() => onConfirm(entry._id)}
            disabled={opLoading}
            style={{ background: '#EF4444', border: 'none', borderRadius: 8, color: '#fff', fontSize: 13, fontWeight: 700, padding: '7px 20px', cursor: opLoading ? 'default' : 'pointer', minWidth: 90, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}
          >
            {opLoading
              ? <span className="admin-loader-sm" style={{ borderTopColor: '#fff' }} />
              : 'Delete'
            }
          </button>
        </div>

      </div>
    </Modal>
  );
};

export default BlacklistDeleteConfirm;
